import { render, staticRenderFns } from "./BaseFlag.vue?vue&type=template&id=7de31905&scoped=true&"
import script from "./BaseFlag.vue?vue&type=script&lang=js&"
export * from "./BaseFlag.vue?vue&type=script&lang=js&"
import style0 from "./BaseFlag.vue?vue&type=style&index=0&id=7de31905&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de31905",
  null
  
)

export default component.exports